import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import store from "store";

import { setApp, setConfig, resetData } from "appredux/configSlice";
import { generateBaseUri } from "utils/helper";
import Axios from "utils/axios";
import { useQueryClient } from "@tanstack/react-query";
import { reconnectPusher } from "utils/pusher";
import { resetChat } from "appredux/chatSlice";
import usePreviousPathname from "./usePreviousPathName";

// Digunakan untuk handle milih perusahaan dan setup aplikasi
const useSelectedCompany = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const from = usePreviousPathname();

  const selectCompanyHandler = (selected, path, withResetRedux = true) => {
    store.set("app.endpoint", selected.endpoint);
    store.remove("app.bootstrapEndpoint");
    Axios.defaults.baseURL = generateBaseUri();
    queryClient.clear();
    if (withResetRedux) {
      dispatch(resetData());
      dispatch(resetChat());
    }

    dispatch(
      setConfig({ selectedCompany: selected, endpoint: selected.endpoint })
    );
    dispatch(setApp({ website_id: selected.website_id }));
    reconnectPusher();
    // dispatch(setLoadedInit(false));
    navigate(path || from || "/", {
      replace: true,
    });
  };

  return { onSelectCompany: selectCompanyHandler };
};

export default useSelectedCompany;
